import { log } from '@/utils/core/vueLogger';

let registration = null;
let refreshing = false;

export async function registerServiceWorker() {
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.addEventListener('controllerchange', () => {
			if (!refreshing) {
				refreshing = true;
				log('info', 'SW', 'New SW took control — reloading to apply update');
				notifyUserOfUpdate();
			}
		});

		try {
			registration = await navigator.serviceWorker.register('/sw.js', {
				scope: '/',
			});

			log('success', 'SW', `Service Worker registered successfully: ${registration.scope}`);

			registration.addEventListener('updatefound', () => {
				const newWorker = registration.installing;
				log('info', 'SW', 'New Service Worker found');

				newWorker.addEventListener('statechange', () => {
					if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
						log('info', 'SW', 'New content is available, please refresh');

						notifyUserOfUpdate();
					}
				});
			});

			setInterval(() => {
				if (!navigator.onLine) return;

				registration.update().catch((error) => {
					log('warn', 'SW', `Service Worker update check failed: ${error.message}`);
				});
			}, 60000);
		} catch (error) {
			log('error', 'SW', `Service Worker registration failed: ${error.message}`);
		}
	} else {
		log('warn', 'SW', 'Service Workers are not supported in this browser');
	}
}

export async function unregisterServiceWorker() {
	if ('serviceWorker' in navigator && registration) {
		try {
			const success = await registration.unregister();
			if (success) {
				log('success', 'SW', 'Service Worker unregistered successfully');
			}
		} catch (error) {
			log('error', 'SW', `Service Worker unregistration failed: ${error.message}`);
		}
	}
}

export function updateServiceWorker() {
	if (registration && registration.waiting) {
		navigator.serviceWorker.addEventListener('controllerchange', () => {
			window.location.reload();
		});
		registration.waiting.postMessage({ type: 'SKIP_WAITING' });
	}

	window.location.reload();
}

export function clearServiceWorkerCache() {
	if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
		navigator.serviceWorker.controller.postMessage({ type: 'CLEAR_CACHE' });
	}
}

function notifyUserOfUpdate() {
	log('info', 'SW', 'A new version is available. Please refresh the page.');
	window.dispatchEvent(new CustomEvent('sw-update-available'));
}
